import { useEffect } from 'react';
import ConstructionInfo from './modules/ConstructionInfo';
import ExteriorInfo from './modules/ExteriorInfo';
import GeneralInfo from './modules/GeneralInfo';
import InteriorInfo from './modules/InteriorInfo';
import ListingWaggle from './modules/ListingWaggle';
import MiscInfo from './modules/MiscInfo';
import Location from './modules/Location';
import './tabs.scss'

const Tabs = ({ data }) => {
    useEffect(() => {
        const initialize = () => {
            const items = document.getElementsByClassName("tab-item").length;
            let tabHeader = document.getElementsByClassName("tab-header")[0];
            let tabIndicator = document.getElementsByClassName("tab-indicator")[0];
            let tabsPane = tabHeader.getElementsByTagName("div");
            let tabBody = document.getElementsByClassName("tab-body")[0];

            for(let i = 0; i < tabsPane.length; i++){
                tabsPane[i].addEventListener("click",() => {
                    tabHeader.getElementsByClassName("active")[0].classList.remove("active");
                    tabsPane[i].classList.add("active");
                    tabBody.getElementsByClassName("active")[0].classList.remove("active");
                    tabBody.getElementsByClassName("tab-body--content")[i].classList.add("active");
                    tabIndicator.style.left = `calc(150px * ${i})`;
                });
            }
        }

        initialize();
    }, [])

    return (
        <div className="listing-tabs-container">
            <div className="tabs" style={{ '--items': 7 }}>
                <div className="tab-header">
                    <div className="tab-item active">
                        <span>Location</span>
                    </div>
                    <div className="tab-item">
                        <span>Waggle</span>
                    </div>
                    <div className="tab-item">
                        <span>General</span>
                    </div>
                    <div className="tab-item"> 
                        <span>Interior</span>
                    </div>
                    <div className="tab-item">
                        <span>Exterior</span>
                    </div>
                    <div className="tab-item">
                        <span>Construction</span>
                    </div>
                    <div className="tab-item">
                        <span>Misc.</span>
                    </div>
                </div>
                <div className="tab-indicator" style={{ '--items': 7 }}></div>
                <div className="tab-body">
                        <div className="tab-body--content active">
                            <Location />
                        </div>
                        <div className="tab-body--content">
                            <ListingWaggle id={data.id} />
                        </div>
                        <div className="tab-body--content">
                            <GeneralInfo data={data} />
                        </div>
                        <div className="tab-body--content">
                            <InteriorInfo data={data} />
                        </div>
                        <div className="tab-body--content">
                            <ExteriorInfo data={data} />
                        </div>
                        <div className="tab-body--content">
                           <ConstructionInfo data={data} />
                        </div>
                        <div className="tab-body--content">
                            <MiscInfo data={data} />
                        </div>
                    </div>
            </div>
        </div>
    )
}

export default Tabs;